export const SETTINGS_WIDTH = '248px';
export const SIDEBAR_DIRECTORY_WIDTH = '248px';
export const SETTINGS_LABEL_WIDTH = '162px';
